export default "__VITE_ASSET__jw2QUkQF__"